import axiosInstance from './axiosInstance';
import config from '../config';
import { Warehouse, CreateWarehouseDto, UpdateWarehouseDto } from '../types/warehouses.types';

const API_URL = `${config.API_BASE_URL}/Warehouses`;

export const warehousesService = {
  getAll: async (): Promise<Warehouse[]> => {
    const response = await axiosInstance.get<Warehouse[]>(API_URL);
    return response.data;
  },

  getById: async (id: number): Promise<Warehouse> => {
    const response = await axiosInstance.get<Warehouse>(`${API_URL}/${id}`);
    return response.data;
  },

  create: async (warehouse: CreateWarehouseDto): Promise<Warehouse> => {
    const response = await axiosInstance.post<Warehouse>(API_URL, warehouse);
    return response.data;
  },

  update: async (id: number, warehouse: UpdateWarehouseDto): Promise<Warehouse> => {
    const response = await axiosInstance.put<Warehouse>(`${API_URL}/${id}`, warehouse);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await axiosInstance.delete(`${API_URL}/${id}`);
  },

  generateCode: async (): Promise<string> => {
    const response = await axiosInstance.get<string>(`${API_URL}/generate-code`);
    return response.data;
  },

  // Excludes warehouses belonging to BranchType='Warehouse' branches — for general pages
  getOperational: async (): Promise<Warehouse[]> => {
    const response = await axiosInstance.get<Warehouse[]>(`${API_URL}?excludeWarehouseBranches=true`);
    return response.data;
  },

  // Same exclusion but via /lookup (no user branch filter) — for WarehouseTransfer FromWarehouse
  getAllForLookupOperational: async (): Promise<Warehouse[]> => {
    const response = await axiosInstance.get<Warehouse[]>(`${API_URL}/lookup?excludeWarehouseBranches=true`);
    return response.data;
  },
};